// extracted by mini-css-extract-plugin
export default {"e":"style_e__-n84+","g":"style_g__K5FEP","edge1":"style_edge1__9vfG-","edge2":"style_edge2__EapMN","edge3":"style_edge3__-GpYw","edge4":"style_edge4__Fd+ue"};